/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// ./src/js/lib/cart/cartWatchSkipHeader.ts
/**
 * Marks a `/cart/*` request as bookkeeping rather than a shopper action, so
 * `cartMutationWatcher` ignores it instead of firing a cart-update cycle.
 *
 * Its own module because the two sides live in different webpack bundles
 * (`bundle.theme.js` installs the watcher, `bundle.analytics-session.js` writes
 * the session cart attributes) and so cannot share a larger one. The previous
 * arrangement had the analytics side capture `window.fetch` at module load to
 * slip past the watcher, which only worked while both ran from the same bundle
 * in a known order — as separate bundles, whichever loads first wins.
 */
var CART_WATCH_SKIP_HEADER = 'X-Nuts-Cart-Watch-Skip';
;// ./src/js/utils/isDefined.ts
function isDefined(t) {
  return t !== undefined;
}
;// ./src/js/utils/cookie.ts


var getSerializedCookies = function getSerializedCookies() {
  return window.document.cookie;
};

/**
 * By default (`T = string`) the decoded value is returned as-is.
 * To parse a JSON-encoded cookie, supply a type parameter and pass
 * `parseJSON: true`:
 *
 *     parseCookieValue<{ id: number }>(raw, true)
 *
 * The conditional type on `parseJSON` prevents callers from passing
 * `true` when `T` is `string` — `JSON.parse` would fail at runtime
 * for most non-JSON string values.
 *
 * Follows the pattern from nuts/webstore@ff2e543 (`getCookie`).
 */
function getCookie(name, parseJSON) {
  try {
    var cookie = getSerializedCookies().split('; ').find(function (val) {
      return val.startsWith("".concat(name, "="));
    });
    if (cookie) {
      var value = cookie.split('=')[1];
      if (value) {
        var decoded = decodeURIComponent(value);
        // JSON.parse returns `any`, which satisfies T without assertion
        // but we must cast the non-parsed to the caller's generic contract
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseJSON ? JSON.parse(decoded) : decoded;
      }
    }
  } catch (_unused) {
    /* invalid cookies count as nonexistent */
  }
  return undefined;
}
var getMaxAge = function getMaxAge(days) {
  return 60 * 60 * 24 * days;
};
var expiresInMonths = function expiresInMonths(months) {
  var avgDaysPerMonth = 30.5;
  return "; max-age=".concat(getMaxAge(avgDaysPerMonth * months));
};
function setCookie(key, value, options) {
  var _options$path, _options$expiresInMon;
  var path = (_options$path = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path !== void 0 ? _options$path : '/';
  var domainAttr = options !== null && options !== void 0 && options.domain ? "; Domain=".concat(options.domain) : '';
  var expiration = isDefined(options === null || options === void 0 ? void 0 : options.expiresInSeconds) ? "; max-age=".concat(options.expiresInSeconds) : expiresInMonths((_options$expiresInMon = options === null || options === void 0 ? void 0 : options.expiresInMonths) !== null && _options$expiresInMon !== void 0 ? _options$expiresInMon : 6);
  var cookieValue = encodeURIComponent(_typeof(value) === 'object' ? JSON.stringify(value) : String(value));
  window.document.cookie = "".concat(key, "=").concat(cookieValue, "; path=").concat(path).concat(domainAttr, "; Secure").concat(expiration);
}

/**
 * Expire a cookie by name. Deletion matches on `(name, domain, path)`, so to
 * remove a specific variant the `domain`/`path` must match how it was written:
 * omit `domain` to delete a host-only cookie, or pass the same `domain` (e.g.
 * `.nuts.com`) to delete a shared-domain cookie.
 */
function deleteCookie(name, options) {
  var _options$path2;
  var path = (_options$path2 = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path2 !== void 0 ? _options$path2 : '/';
  var domainAttr = options !== null && options !== void 0 && options.domain ? "; Domain=".concat(options.domain) : '';
  window.document.cookie = "".concat(name, "=; path=").concat(path).concat(domainAttr, "; max-age=0");
}
;// ./src/js/utils/session-cookie.ts
/**
 * Resolve the cookie `Domain` for the `rs_session` cookie based on the current
 * host. Returns `.nuts.com` on any nuts.com host (`shop.nuts.com`,
 * `account.nuts.com`, and the future `nuts.com`) so the session cookie is
 * shared across every subdomain and a single visitor keeps one session as they
 * cross hosts — fixing the duplicate-session spike caused by host-only cookies.
 *
 * Returns `undefined` (host-only) on preview/dev hosts (`*.myshopify.com`,
 * `localhost`, `127.0.0.1`) where a `.nuts.com` Domain would be rejected by the
 * browser and silently drop the cookie.
 *
 * Matches `nuts.com` and any `*.nuts.com` subdomain, but not lookalikes such as
 * `evil-nuts.com` (the char before `nuts` must be `.` or the string start).
 */
function resolveSessionCookieDomain(hostname) {
  return /(^|\.)nuts\.com$/i.test(hostname) ? '.nuts.com' : undefined;
}
;// ./src/js/utils/rudderstack-utils.ts





function getOrCreateRsSession() {
  var COOKIE_NAME = 'rs_session';
  // keep in sync with shopify-apps/nuts-analytics-pixel/extensions/nuts-analytics-pixel/src/identity.ts#readSessionFromEvent
  var SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 min — session staleness, enforced in code
  var COOKIE_TTL_SECONDS = 24 * 60 * 60; // 24h — cookie must outlive the timeout
  // Scope to .nuts.com so the session is shared across shop./account./apex and
  // survives cross-host journeys (the source of the duplicate-session spike).
  var domain = resolveSessionCookieDomain(window.location.hostname);
  var stored = getCookie(COOKIE_NAME, true);
  // Valid JSON can still decode to a primitive; only an object is a session.
  var parsed = _typeof(stored) === 'object' ? stored : undefined;
  var reuse = !!(parsed !== null && parsed !== void 0 && parsed.id) && Date.now() - parsed.lastActivity < SESSION_TIMEOUT_MS;
  var id = reuse ? parsed.id : Date.now();
  setCookie(COOKIE_NAME, {
    id: id,
    lastActivity: Date.now()
  }, {
    expiresInSeconds: COOKIE_TTL_SECONDS,
    domain: domain
  });

  // Migration cleanup: when we write the shared .nuts.com cookie, remove any
  // pre-existing host-only rs_session. Otherwise getCookie could read the stale
  // host-only cookie first (same name, different domain) and mint duplicate
  // sessions until it expires. No-op once the host-only cookie is gone.
  if (domain) deleteCookie(COOKIE_NAME);
  return {
    id: id,
    start: !reuse
  };
}
function publishRsSession() {
  var _window$Shopify;
  var publish = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.analytics) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.publish;
  if (typeof publish !== 'function') {
    setTimeout(publishRsSession, 100);
    return;
  }
  var session = getOrCreateRsSession();
  publish('nuts:rudderstack_session', session);
  syncCartAttributes(session);
}

// Reading `window.sessionStorage` throws (rather than returning null) where
// storage is partitioned or blocked — notably the Meta in-app browsers, whose
// webviews we see this from most often. Losing the redundant-POST guard costs an
// extra idempotent /cart/update.js per page for that cohort; letting the throw
// escape costs the session entirely, so both accessors degrade to "nothing
// cached". Logged once per page so the cohort is diagnosable without flooding
// the console.
var storageErrorLogged = false;
function logStorageError(error) {
  if (storageErrorLogged) return;
  storageErrorLogged = true;
  console.error('sessionStorage unavailable; cart attributes will re-sync', error);
}
function readSyncMarker(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    logStorageError(error);
    return null;
  }
}
function writeSyncMarker(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    logStorageError(error);
  }
}

/**
 * Syncs all cart attributes needed for server-side tracking in a single
 * POST to avoid concurrent /cart/update.js race conditions. Combines:
 *   - Rudderstack session ID + external ID
 *   - Meta _fbc / _fbp cookies (click ID and browser ID for CAPI)
 *
 * A sessionStorage guard keyed on all values prevents redundant POSTs.
 */
function syncCartAttributes(session) {
  var fbc = getCookie('_fbc');
  var fbp = getCookie('_fbp');
  var externalId = window.__nuts_external_id__;
  var SYNCED_KEY = 'cart_attrs_synced';
  // Every value that goes into the POST belongs in the key. `externalId` in
  // particular: it is set by an inline script during parse, so a publish that
  // beats it would otherwise cache "synced" without it and never repair the
  // omission — and the checkout attribute is the only place a standard event
  // carries the external id.
  var cacheValue = "".concat(session.id, "|").concat(externalId !== null && externalId !== void 0 ? externalId : '', "|").concat(fbc !== null && fbc !== void 0 ? fbc : '', "|").concat(fbp !== null && fbp !== void 0 ? fbp : '');
  if (readSyncMarker(SYNCED_KEY) === cacheValue) return;
  var attributes = {
    rs_session_id: String(session.id)
  };
  if (externalId) attributes.nuts_external_id = String(externalId);
  if (fbc) attributes._fbc = fbc;
  if (fbp) attributes._fbp = fbp;
  window.fetch('/cart/update.js', {
    method: 'POST',
    headers: _defineProperty({
      'Content-Type': 'application/json'
    }, CART_WATCH_SKIP_HEADER, '1'),
    credentials: 'same-origin',
    body: JSON.stringify({
      attributes: attributes
    })
  }).then(function () {
    writeSyncMarker(SYNCED_KEY, cacheValue);
  })["catch"](function (error) {
    // Never surfaced to the customer: a failed sync degrades server-side
    // attribution, it does not break the page.
    console.error('Cart attribute sync failed', error);
  });
}
;// ./src/js/bundles/layout/analytics-session.ts
/*
 * Standalone layout entry whose only job is to publish the RudderStack session.
 *
 * It is deliberately kept out of `theme.js`. Import evaluation there runs React,
 * Alpine, Swiper and Algolia before any of the bundle's own statements, which on
 * a slow device pushes the session publish well past Shopify's `page_viewed`.
 * The pixel then has no session id to attach to the first — and on a bounced
 * visit, only — event of the visit. As its own tiny bundle this can be loaded
 * `async` and run shortly after parse, well ahead of the deferred bundle.
 *
 * `theme.js` still calls `publishRsSession()` as a backstop for the visit where
 * this asset fails to load, so a broken request degrades to a late session
 * rather than none at all.
 *
 * Keep this entry dependency-light; anything imported here is on the critical
 * path for every page.
 */

publishRsSession();
/******/ })()
;